import React, { FC, memo } from "react";
import ReactMarkdown, { Options, Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";

const MemoizedReactMarkdown: FC<Options> = memo(
	ReactMarkdown,
	(prevProps, nextProps) =>
		prevProps.children === nextProps.children &&
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		prevProps.className === nextProps.className,
);

type MarkdownProps = {
	content: string;
};

export const Markdown = ({ content }: MarkdownProps): JSX.Element => (
	<div className="copilotKitMarkdown">
		<MemoizedReactMarkdown
			components={components}
			remarkPlugins={[remarkGfm, remarkMath]}
		>
			{content}
		</MemoizedReactMarkdown>
	</div>
);

const components: Components = {
	a({ children, ...props }) {
		return (
			<a
				style={{ color: "blue", textDecoration: "underline" }}
				{...props}
				target="_blank"
				rel="noopener noreferrer"
			>
				{children}
			</a>
		);
	},
};
